<template>
  <div>
    <div class="product-name mb-3 d-none d-sm-block">
      {{ product.description }}
    </div>
    <div class="mb-3">
      <div v-for="(substance, index) in product.substances" :key="index">
        {{ substance.description }}
      </div>
    </div>
    <div>
      <div v-for="(presentation, index) in product.presentations" :key="index">
        {{ presentation.content_unit_quantity }}
        {{ presentation.content_unit }}
      </div>
    </div>
    <div
      v-if="['II','III','IV'].includes(product.fraction)"
      class="mt-4"
    >*{{ $t('product_summary.fraction_message_medical_recipe_needed') }}.</div>
    <div
      v-else-if="product.fraction=='I'"
      class="mt-4"
    >*{{ $t('product_summary.fraction_message_recipe_needed') }}.</div>
    <div
      v-else-if="product.fraction=='XIV'"
      class="mt-4"
    >
      {{ $t('product_summary.fraction_message_milk_warning') }}:
      <ol type="a">
        <li>{{ $t('product_summary.fraction_message_milk_warning_a') }}</li>
        <li>{{ $t('product_summary.fraction_message_milk_warning_b') }}</li>
        <li>{{ $t('product_summary.fraction_message_milk_warning_c') }}</li>
      </ol>
    </div>
    <div
      v-else-if="product.fraction=='X'"
      class="mt-4 text-uppercase"
    >{{ $t('product_summary.fraction_message_hygiene_is_health') }}</div>
  </div>
</template>


<script>
export default {
  name: "product-summary",
  props: {
    product: Object,
  },
  fallbackI18n: {
    messages: {
      und: {
        product_summary: {
          fraction_message_medical_recipe_needed:
            "This product requires Medical Recipe for its purchase",
          fraction_message_recipe_needed:
            "This product requires Recipe or a Special Permit issued by the Department of Health for its purchase",
          fraction_message_milk_warning:
            "The use of infant formulas is recommended only in the following cases",
          fraction_message_milk_warning_a:
            "Due to the child's intolerance to breast milk",
          fraction_message_milk_warning_b: "In the absence of the mother",
          fraction_message_milk_warning_c:
            "Due to the mother's inability to give milk or for any other founded health reason",
          fraction_message_hygiene_is_health: "Hygiene is health",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.product-name {
  color: $text-third-color;
  font-size: 1.5rem;
}
</style>
